$( document ).ready(function() {
    $('.tt-carousel-products-js').slick({
        centerMode: true,
    	centerPadding: '20%',
    });
  	$('.tt-carousel-products').slick({
        centerMode: true,
    	centerPadding: '20%',
    });
 
});